<!-- TicketLog.vue -->
<template>
  <div class="chat-content d-flex" :class="alignmentClass">
    <div class="chat-body" :class="chatBodyClass">
      <div class="chat-message">
        <div class="d-flex align-items-center mb-1">
          <b-avatar
              size="28"
              :src="avatarSrc"
          />
          <span class="font-weight-bold ml-2">{{ senderName }}</span>
          <small class="text-muted mr-2">{{ formatDate(chatData.createdAt) }}</small>
        </div>
        <p class="mb-0">{{ chatData.content }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { BAvatar } from "bootstrap-vue";

export default {
  props: {
    chatData: {
      type: Object,
      required: true,
    },
    isAdmin: {
      type: Boolean,
      default: false,
    },
    userName: {
      type: String,
      default: "کاربر",
    },
    adminName: {
      type: String,
      default: "پشتیبان",
    },
  },
  components: {
    BAvatar,
  },
  computed: {
    alignmentClass() {
      return this.isAdmin ? "justify-content-start" : "justify-content-end";
    },
    chatBodyClass() {
      return this.isAdmin ? "bg-light-primary" : "bg-light-success";
    },
    senderName() {
      return this.isAdmin ? this.adminName : this.userName;
    },
    avatarSrc() {
        return require("@/assets/images/logo/logo-dark.png");
    },
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      return new Intl.DateTimeFormat("fa-IR", {
        hour: "2-digit",
        minute: "2-digit",
        year: "numeric",
        month: "numeric",
        day: "numeric",
      }).format(date);
    },
  },
};
</script>

<style scoped>
.chat-content {
  margin-bottom: 1rem;
}
.chat-body {
  max-width: 70%;
  padding: 0.75rem;
  border-radius: 0.5rem;
}
.bg-light-primary {
  background-color: #e3f2fd;
}
.bg-light-success {
  background-color: #e8f5e9;
}
</style>
